import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyContainerModel } from '../../../../../models/aggregates/company';
import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config, Pagination, PagingResponseModel } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class T2TCompanyService extends BaseApiTemplateService<CompanyContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + Core2Config.ERP_PREFIX + 'companies';
    this.httpClient = http;
  }

  public getTenantCompanyByGuid(guid: string, tenantCode: string, visa: ApiVisa): Observable<BasicApiResponseModel<CompanyContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode;
    }
    return this.httpClient.get<BasicApiResponseModel<CompanyContainerModel>>(
      this.apiUrl + '/query?' + "hdr_guids=" + guid,
      this.getHttpHeader(visa)
    );
  }

  getTenantCompanies(pagination: Pagination, tenantCode: string,  visa: ApiVisa): Observable<PagingResponseModel<CompanyContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<CompanyContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
  
}